import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Stack, Card, Container } from '@mui/material';
import { sendVerificationCode } from '../../api/auth';
import InputConfig from '../../Components/InputConfig';
import { LoadingButton } from '@mui/lab';
import useCommonStyles from '../../commonStyles';
import { toast } from 'react-toastify';

import { styled } from '@mui/material/styles';

import MHidden from '../../Components/Mhidden';
import LoginSvg from '../../assets/svgs/login.svg';
import { isValidEmail } from '../../utilities/helpers';

// Styled Components

const RootStyle = styled('div')(({ theme }) => ({
	[theme.breakpoints.up('md')]: {
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%'
	}
}));

const SectionStyle = styled(Card)(({ theme }) => ({
	width: '100%',
	maxWidth: 464,
	maxHeight: '100vh',
	minHeight: '90vh',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	margin: theme.spacing(2, 0, 2, 2),
	boxShadow: 16
}));

const ContentStyle = styled('div')(({ theme }) => ({
	maxWidth: 480,
	margin: 'auto',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	padding: theme.spacing(12, 0),
	color: theme.palette.primary.main
}));

export default function ForgotPasswordPage() {
	return (
		<RootStyle>
			<MHidden width="mdDown">
				<SectionStyle>
					<img src={LoginSvg} alt="login" />
				</SectionStyle>
			</MHidden>

			<Container>
				<ContentStyle>
					<Stack sx={{ mb: 5 }}>
						<Typography variant="h4" gutterBottom fontWeight="bold">
							Forgot Password ?
						</Typography>
						<Typography sx={{ color: 'text.secondary' }}>Enter Email to reset password</Typography>
					</Stack>

					<ForgotPasswordForm />
				</ContentStyle>
			</Container>
		</RootStyle>
	);
}

function ForgotPasswordForm() {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [isSendingCode, setIsSendingCode] = useState(false);
	const commonStyleClasses = useCommonStyles();

	const handleCodeSendingToEmail = async () => {
		if (!isValidEmail(email)) {
			toast.error('Email invalid! Please enter email.');
			return;
		}
		setIsSendingCode(true);
		try {
			await sendVerificationCode({ email });
			toast.success('Verification Code Sent Successfully to your email');
			navigate(`/verify-code?email=${email}&forgotPassword=true`, { replace: true });
		} catch (error) {
			toast.error('Error Sending Verification Code');
		} finally {
			setIsSendingCode(false);
		}
	};

	return (
		<Grid container>
			<Grid item xs={12}>
				<InputConfig
					inputStyles={{ width: '100%', margin: '1rem 0' }}
					isObjectEditor={false}
					directValue={email}
					updateDirectValue={(value) => {
						setEmail(value);
					}}
					placeholder="xyz@gmail.com"
					label="Email"
				/>
			</Grid>
			<Grid item xs={12}>
				<LoadingButton
					className={`${commonStyleClasses.mediumMarginTopAndBottom}`}
					color="primary"
					variant="contained"
					size="medium"
					onClick={handleCodeSendingToEmail}
					disabled={!isValidEmail(email)}
					loading={isSendingCode}
				>
					<Typography fontWeight="bold">Get Code via Email</Typography>
				</LoadingButton>
			</Grid>
		</Grid>
	);
}
